<flx-header-home [area]="area()" />

@if (showSwitcher()) {
  <flx-workspaces-switch />
}

@if (projectHeader(); as outlet) {
  <ng-container
    *ngComponentOutlet="
      outlet.component;
      injector: outlet.injector;
      environmentInjector: outlet.environmentInjector
    "
  />
} @else {
  <flx-ai-builder-toggle />
}

<div class="flex items-center gap-x-1 ml-auto">
  <flx-notifications-center />
  <flx-account-menu />
</div>
